import '@saesa/ui-kit-front/lib/esm/assets/fonts/stylesheet.css';
import '@saesa/ui-kit-front/lib/esm/styles/colors.css';
import '@saesa/ui-kit-front/lib/esm/styles/reset.css';
import '@saesa/ui-kit-front/lib/esm/styles/styles.css';
import App from 'App';
import { AuthInterceptor } from 'config';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import AnalyticsService from 'services/AnalyticsService';
import reportWebVitals from './reportWebVitals';
import { store } from './store';

/**
 * Metodo que inicializa GTM
 */
AnalyticsService.inicializarGTM();

sessionStorage.setItem('loading', '0');
AuthInterceptor();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
